var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuillLightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_808",
    "data-name": "Group 808",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.754 35.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6089bd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "cls-1",
    d: "M6.751,25.776c-1.841-4.91.614-7.365,4.3-9.819l-.614,3.682c1.227-.614,0-3.682,6.751-6.751,0,0-.614,2.455,0,2.455,3.069-4.91,1.841-.614,6.137-5.523.614,0-.614,1.841,0,1.841,1.227-2.455,2.455-2.455,5.523-5.523V7.978C31.3,4.3,31.3,5.523,33.754,0c0,10.433-2.455,10.433-5.523,14.115l2.455-1.227c-4.3,6.751-6.137,4.3-7.978,6.137,0,0,3.069-.614,3.069,0-7.978,7.365-8.592,3.682-11.661,4.91-.614.614,1.841,1.841,1.227,1.841C12.888,27,11.047,27.617,8.592,27c-.614.614,1.227.614,1.227,1.227H7.978l.614,1.841L7.365,28.845l-.614,1.841-.614-2.455A22.36,22.36,0,0,1,0,34.982c.614-2.455,3.682-5.523,5.523-7.365,0,0-1.841-1.841-2.455-1.841H4.91s-1.227-1.841-1.227-1.227l1.227.614V23.935C6.137,23.321,6.751,25.776,6.751,25.776Zm2.455,0C11.661,23.321,27,12.888,29.458,9.206,25.776,13.5,14.115,19.639,7.365,26.39c-1.841,1.227-4.3,3.682-4.91,5.523C2.455,32.527,7.978,26.39,9.206,25.776Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    className: "cls-1",
    d: "M0,13.277c7.978-.614,10.433-.614,18.411-4.91,7.365-3.682,10.433-4.91,11.047-3.682.614.614-1.227,2.455-1.841,3.069,0,2.455,2.455,2.455,3.682,2.455v.614A3.271,3.271,0,0,1,27,7.754C27,7.14,28.845,5.3,28.845,5.3c-.614-1.227-3.069.614-10.433,4.3C10.433,13.277,8.592,13.891,0,13.277Z",
    transform: "translate(0 21.705)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuillLightBlue);
export default __webpack_public_path__ + "static/media/icon-quill-light-blue.0f04e74d5e23cb0c177dd8f6ade1f136.svg";
export { ForwardRef as ReactComponent };